'use memo';

import { cn } from '@/lib/cn';
export type ShadowType = 'it' | 'id' | 'ai';

// メンバー概要のスレート単一トーンに合わせ、種別はバー/凡例/チャートと同じ
// slate スケール（600 / 400 / 300）で識別する。
const styleByType: Record<ShadowType, string> = {
  it: 'bg-slate-600 text-white',
  id: 'bg-slate-400 text-white',
  ai: 'bg-slate-200 text-slate-700'
};
const labelByType: Record<ShadowType, string> = {
  it: 'IT',
  id: 'ID',
  ai: 'AI'
};

/** シャドー種別（IT / ID / AI）を表す色付きバッジ。略号は言語非依存のため固定表記。 */
export function ShadowTypeBadge({
  type
}: {
  type: ShadowType;
}) {
  return <span className={cn('inline-flex items-center rounded-md px-1.5 text-badgeLabel leading-snug', styleByType[type])}>
      {labelByType[type]}
    </span>;
}